module.exports = __webpack_public_path__ + "@/assets/img/login-bg.227b7ab6.jpg";